import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Header from './Header';
import Footer from './Footer';

const useStyles = makeStyles({
  '@global': {
    body: {
      margin: 0,
    },
  },
  frame: {},
  header: {},
  footer: {},
  app: {
    position: 'relative',
    height: '56.25vw', // 16:9
    maxHeight: '80vh',
    minHeight: '50vh',
    paddingBottom: 8,
  },
});

export const Frame = ({ children }) => {
  const classes = useStyles();
  return (
    <div className={classes.frame}>
      <Suspense fallback={'loading header...'}>
        <Header className={classes.header} />
      </Suspense>
      <div className={classes.app}>{children}</div>
      <Suspense fallback={'loading footer...'}>
        <Footer className={classes.footer} />
      </Suspense>
    </div>
  );
};

Frame.propTypes = {
  children: PropTypes.node,
};

export default Frame;
